var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 0c-11.02201 0-20 8.97799-20 20 0 11.022 8.97799 20 20 20 11.022 0 20-8.978 20-20 0-11.02201-8.978-20-20-20zm0 4c8.8602 0 16 7.1398 16 16s-7.1398 16-16 16-16-7.1398-16-16 7.1398-16 16-16zm-4 9.0703v13.8594l12-6.9297z",
    fill: "currentColor"
  })));
}
export default SvgPlayreact;